import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/hr';

import { DATE_FORMAT_BLOG_EN, DATE_FORMAT_BLOG_HR } from '@/config/date-time.config';

export default class DateTime {
  public static now = () => dayjs();

  public static date = (date: string) => dayjs(date);

  public static formatBlogDate = (date: Dayjs | string, locale: string): string => {
    const d = typeof date === 'string' ? dayjs(date) : date;

    if (locale === 'hr') {
      return d.locale('hr').format(DATE_FORMAT_BLOG_HR);
    }

    return d.locale('en').format(DATE_FORMAT_BLOG_EN);
  };
}
